(ns common.schema.entities.decision-condition
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]))

(def condition-status-options
  [{:key   :decision-condition.status/true
    :label "Yes"}
   #_{:key   :decision-condition.status/conditionally-true
      :label "Conditionally true"}
   {:key   :decision-condition.status/false
    :label "No"}])

(def schema
  (concat

   (su/text-simple-field :decision-condition/title
                         "Title"
                         {:authorization su/access-user-user})

   (su/text-multiline-field :decision-condition/description
                            "Description"
                            {:authorization su/access-user-user})

   (su/keyword-field :decision-condition/status
                     "Condition status"
                     condition-status-options
                     {:authorization su/access-user-user})

   (su/date-field :decision-condition/completed-on
                  "Completed on"
                  {:authorization su/access-user-user})

   #_(su/boolean-field :decision-condition/completed
                       "Completed"
                       {:authorization su/access-user-user})

   (su/single-ref-field :decision-condition/completed-by
                        "Completed by"
                        [:entity.type/account]
                        {:authorization su/access-user-user})))

(def required-fields
  #{:decision-condition/title
    :decision-condition/status})
